import initialState from './initialState';

export function offerListHasErrored(
  state = initialState.offerListHasErrored,
  action,
) {
  switch (action.type) {
    case 'OFFER_LIST_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
export function offerListIsLoading(
  state = initialState.offerListIsLoading,
  action,
) {
  switch (action.type) {
    case 'OFFER_LIST_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function offerList(state = initialState.offerList, action) {
  switch (action.type) {
    case 'OFFER_LIST_FETCH_DATA_SUCCESS':
      return action.offerList;
    default:
      return state;
  }
}

export function offerDetailsHasErrored(
  state = initialState.offerDetailsHasErrored,
  action,
) {
  switch (action.type) {
    case 'OFFER_DETAILS_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
export function offerDetailsIsLoading(
  state = initialState.offerDetailsIsLoading,
  action,
) {
  switch (action.type) {
    case 'OFFER_DETAILS_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function offerDetails(state = initialState.offerDetails, action) {
  switch (action.type) {
    case 'OFFER_DETAILS_FETCH_DATA_SUCCESS':
      return action.offerDetails;
    default:
      return state;
  }
}

export function offerRule(state = initialState.offerRule, action) {
  switch (action.type) {
    case 'OFFER_RULE_FETCH_DATA_SUCCESS':
      return action.ruleList;
    case 'ADD_OFFER_RULE_DATA_SUCCESS':
      return [...state, action.offerRule];
    case 'UPDATE_OFFER_RULE_DATA_SUCCESS':
      return state.map((rule) =>
        rule.id === action.offerRule.id ? action.offerRule : rule,
      );
    case 'REMOVE_OFFER_RULE_DATA_SUCCESS':
      return state.filter((currRule) => currRule.id !== action.offerRule.id);
    default:
      return state;
  }
}

export function redirectToOfferListPage(
  state = initialState.redirectToOfferListPage,
  action,
) {
  switch (action.type) {
    case 'REDIRECT_TO_OFFER_LIST':
      return action.doRedirectToOfferListPage;
    default:
      return state;
  }
}

export function isNewOfferSaveSuccess(
  state = initialState.isNewOfferSaveSuccess,
  action,
) {
  switch (action.type) {
    case 'NEW_OFFER_SAVE_SUCCESS':
      return {
        isSavedSuccess: action.isSavedSuccess,
        offer: action.offer,
      };
    default:
      return state;
  }
}

export function isNewOfferSaveErrored(
  state = initialState.isNewOfferSaveErrored,
  action,
) {
  switch (action.type) {
    case 'NEW_OFFER_SAVE_ERRORED':
      return {
        isSaveErrored: action.isSaveErrored,
        message: action.message,
      };
    default:
      return state;
  }
}

export function isNewOfferIsSaving(
  state = initialState.isNewOfferIsSaving,
  action,
) {
  switch (action.type) {
    case 'NEW_OFFER_IS_SAVING':
      return action.isSaving;
    default:
      return state;
  }
}

export function activateOfferDataSuccess(
  state = initialState.activateOfferDataSuccess,
  action,
) {
  switch (action.type) {
    case 'ACTIVATE_OFFER_DATA_SUCCESS':
      return action.hasActivated;
    default:
      return state;
  }
}

export function activateOfferSaving(
  state = initialState.activateOfferSaving,
  action,
) {
  switch (action.type) {
    case 'OFFER_IS_ACTIVATING':
      return action.isLoading;
    default:
      return state;
  }
}

export function activateOfferErrored(
  state = initialState.activateOfferErrored,
  action,
) {
  switch (action.type) {
    case 'ACTIVATE_OFFER_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
